import createIcon from '../../createIcon';

/**
 * @component @name VideoLibrary
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA2SDJWMjBDMiAyMS4xIDIuOSAyMiA0IDIySDE4VjIwSDRWNlpNMjAgMkg4QzYuOSAyIDYgMi45IDYgNFYxNkM2IDE3LjEgNi45IDE4IDggMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xMiAxNC41VjUuNUwxOCAxMEwxMiAxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoLibrary = createIcon('VideoLibrary', [
  [
    'path',
    {
      d: 'M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12 14.5V5.5L18 10L12 14.5Z',
      key: '1wdfli',
    },
  ],
]);

export default VideoLibrary;
